const o = "_noRowsContainer_362ej_1", n = "_noRowsIllustration_362ej_9", t = "_buttonsContainer_362ej_12", s = "_twoLines_362ej_18", e = "_oneButton_362ej_22", _ = {
  noRowsContainer: o,
  noRowsIllustration: n,
  buttonsContainer: t,
  twoLines: s,
  oneButton: e
};
export {
  t as buttonsContainer,
  _ as default,
  o as noRowsContainer,
  n as noRowsIllustration,
  e as oneButton,
  s as twoLines
};
//# sourceMappingURL=index.es751.js.map
